import React, { useEffect, useCallback, useState} from 'react';
import {isNumber} from "utils/IsNumber.js";
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {connect} from 'react-redux';

const PianoSlider = ({name, value, onChange, step, min, max}) => { 
    let [editing, setEditing] = useState(false);
    let [text, setText] = useState(value);

    let _onChange = useCallback((e) => {
        let value = e.target.value;
        if (value === '.' || value === '-.') {
            value = 0;
        } else if (value === '-') {
            value = 0;
        } else if (value === '') {
            value = 0;
        } else if (!isNumber(value)) {
            return;
        } else {
            value = parseFloat(value);
        }
        setText(value);
        onChange({target: {value: value}});
    }, [onChange, setText]);

    useEffect(() => {
        setText(value);
    }, [value, setText]);

    return (
        <div className="piano-slider">
          <div className="slider-value">
            {name}: <input className="value-input" value={text} onChange={_onChange}/>
          </div>
          <ReactBootstrapSlider
            value={value}
            change={onChange} 
            step={step}
            max={max}
            min={min}
            orientation="horizontal"
            reversed={false}
          />
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoSlider);
